import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { CurrencyUnit, IMarketBase, IRoundBase } from '@/types'
import { getFormattedAmount } from '@/utils'
import styles from './index.module.scss'

type Props = {
  investmentTargetMarkets: IMarketBase[]
  investmentTargetRounds: IRoundBase[]
  minInvestmentAmount: number
  maxInvestmentAmount: number
  currencyUnit: CurrencyUnit
}

export const ProfileInvestmentPolicy: FC<Props> = ({
  investmentTargetMarkets,
  investmentTargetRounds,
  minInvestmentAmount,
  maxInvestmentAmount,
  currencyUnit,
}) => {
  const { t } = useTranslation(['companies-users-[id]'])
  return (
    <div className={styles.container}>
      {/* TODO content__text が長いとスタイルが崩れる。container は flex-wrap: wrap されるが、
      content__text 単体が width: 100% からはみ出す場合のデザインを考える必要あり。 */}
      <div className={styles.content}>
        <div className={styles.content__title}>{t('投資対象領域')}</div>
        <div className={styles.content__text}>
          {investmentTargetMarkets.length > 0
            ? investmentTargetMarkets.map((market) => {
                return (
                  <span key={market.slug} className={styles.content__word}>
                    {' '}
                    {t(market.name)}
                  </span>
                )
              })
            : '-'}
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.content__title}>{t('投資対象ラウンド')}</div>
        <div className={styles.content__text}>
          {investmentTargetRounds.length > 0
            ? investmentTargetRounds.map((round) => {
                return (
                  <span key={round.slug} className={styles.content__word}>
                    {' '}
                    {t(round.name)}
                  </span>
                )
              })
            : '-'}
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.content__title}>{t('投資サイズ')}</div>
        <div className={styles.content__text}>
          {minInvestmentAmount > 0 || maxInvestmentAmount > 0 ? (
            <>
              {getFormattedAmount(minInvestmentAmount, currencyUnit)} ~{' '}
              {getFormattedAmount(maxInvestmentAmount, currencyUnit)}
            </>
          ) : (
            '-'
          )}
        </div>
      </div>
    </div>
  )
}
